import React from "react";

// Single source of truth for scored-universe data across screens. App.js owns
// the actual state + scoring callbacks and feeds them in via UniverseDataProvider;
// any descendant can then call useUniverseData() instead of threading props
// through every screen.
const UniverseDataContext = React.createContext(null);

export function UniverseDataProvider({ value, children }) {
  return (
    <UniverseDataContext.Provider value={value}>
      {children}
    </UniverseDataContext.Provider>
  );
}

export function useUniverseData() {
  const ctx = React.useContext(UniverseDataContext);
  if (!ctx) {
    // Screens still on prop-drilling pass their own copy — return an empty shape
    // so components written against the hook don't crash when rendered outside
    // the provider during incremental adoption.
    return {
      data: {},
      phase: 0,
      upsertUniverse: () => {},
      resetUniverse: () => {},
      refresh: () => {},
    };
  }
  return ctx;
}
